import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-prevent-loss-all',
  templateUrl: './prevent-loss-all.component.html',
  styleUrls: ['./prevent-loss-all.component.css']
})
export class PreventLossAllComponent implements OnInit {

  innerHeight: number = window.innerHeight;

  constructor(
    public dialogRef: MatDialogRef<PreventLossAllComponent>,
    @Inject(MAT_DIALOG_DATA) data:any
  ) { }

  ngOnInit() { }

  close(choice: boolean) {
    this.dialogRef.close(choice);
  }

}
